var path = '/pages/picklists/views/contacts/contacts.tpl.html';
var html = "<div class=\"height-less-navbar\" ng-show=\"$state.current.data.subview == 'contacts-list'\" ui-view=\"contacts-list\"></div>\n<div class=\"height-less-navbar\" ng-show=\"$state.current.data.subview == 'contacts-details'\" ui-view=\"contacts-details\"></div>\n<div class=\"height-less-navbar\" ng-show=\"$state.current.data.subview == 'picklist-details'\" ui-view=\"picklist-details\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/picklists/views/contacts/contacts.tpl.html
// module id = 2301
// module chunks = 1